import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SnackbarService } from '../../../services/snackbar.service';
import { SpinnerService } from '../../../services/spinner.service';
import { ValidateService } from '../../../services/validate.service';
import {
  AdheridosPrevisionResiduosControllerService,
  GestoresResiduosControllerService,
  PageDTOGestoresResiduosDTO,
  PrevisionResiduosAdheridoPayloadDTO,
} from 'api-rest';
import { Adherido } from '../../../models/adherido';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';

@Component({
  selector: 'app-waste-forecast-add-dialog',
  templateUrl: './waste-forecast-add-dialog.component.html',
  styleUrls: ['./waste-forecast-add-dialog.component.scss'],
})
export class WasteForecastAddDialogComponent implements OnInit {
  formGroup!: FormGroup;
  suministraInfoList = [
    { id: 'Gestor', name: 'Gestor' },
    { id: 'Adherido', name: 'Adherido' },
  ];
  anios: any[] = [];
  codigosLerEndpoint =
    this.environment.urlBackCore + 'api/v1/core/codigo-ler/filtro-combo?sddrCC=true';
  updateList: boolean = false;
  flagDisabledForm: boolean = false;
  anioActual!: number;
  savingData: boolean = false;
  label: string = 'Añadir previsión';
  adheridoInfo!: Adherido;
  grid: any[] = [];

  constructor(
    private formBuilder: FormBuilder,
    @Inject('environment') private environment: any,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private validateSrv: ValidateService,
    private gestoresResiduosControllerService: GestoresResiduosControllerService,
    private adheridosPrevisionResiduosControllerService: AdheridosPrevisionResiduosControllerService,
    @Inject('EmpusaAuthenticationService')
    private authService: EmpusaAuthenticationService | any,
    @Inject(MAT_DIALOG_DATA)
    public data: { adheridoInfo: Adherido; previsiones: any[] },
    public dialogRef: MatDialogRef<WasteForecastAddDialogComponent>
  ) {
    this.adheridoInfo = this.data.adheridoInfo;
    this.grid = this.data.previsiones ?? [];
    this.formGroup = this.formBuilder.group({
      anio: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      codigoLer: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      nima: [
        { value: null, disabled: false },
        {
          validators: Validators.compose([
            Validators.required,
            Validators.pattern(this.validateSrv.nimaPattern),
            Validators.maxLength(10),
          ]),
        },
      ],
      suministraInfo: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
    });
  }

  ngOnInit(): void {
    this.anioActual = new Date().getFullYear();
    if (this.canViewResource('PO-ENV-GEST')) {
      this.anios.push({ id: this.anioActual - 1 });
    }
    this.anios.push({ id: this.anioActual });
    this.anios.push({ id: this.anioActual + 1 });
    this.formGroup.get('anio')?.setValue(this.anioActual);
  }

  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  getLerDescription(ler: any) {
    if (!ler || (!ler.tipoCodigo && !ler.descripcion && !ler.id)) return '';
    return (ler.tipoCodigo ?? '') + ' - ' + (ler.descripcion ?? '');
  }

  getFormControl(selectForm: any): FormControl {
    switch (selectForm) {
      case 'codigoLer': {
        return this.formGroup.get('codigoLer') as FormControl;
      }
      default: {
        return this.formGroup.get('') as FormControl;
      }
    }
  }

  getObjectQuery(searchterm: string) {
    return {
      descripcion: searchterm,
    };
  }

  public rightHolder(controlName: string) {
    let cl2 = '';
    if (
      (this.formGroup.controls[controlName]?.touched ||
        this.formGroup.controls[controlName]?.dirty) &&
      this.formGroup.controls[controlName]?.errors
    ) {
      cl2 = 'error-focus-input';
    } else {
      cl2 = 'success-focus-input';
    }
    return `${cl2}`;
  }

  selPaginatorHasError(controlName: string) {
    return !!(
      (this.formGroup.controls[controlName]?.touched ||
        this.formGroup.controls[controlName]?.dirty) &&
      this.formGroup.controls[controlName]?.errors
    );
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.formGroup.controls[controlName].hasError(errorName) &&
      this.formGroup.controls[controlName].touched
    );
  }

  onInput(controlName: string, event: any) {
    const control = this.formGroup.get(controlName);
    control?.markAsTouched();
    control?.markAsDirty();
  }

  addPrevision(): void {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
      this.snackBarSrv.showSnackBar(
        'Revisar los errores en los campos ',
        'error'
      );
      return;
    }
    if (this.savingData) {
      return;
    }
    const existe = this.grid.find(
      (x) =>
        x.anioDatos === this.formGroup.get('anio')?.value &&
        x.codigoLer?.id === this.formGroup.get('codigoLer')?.value?.id &&
        x.nimaGestor === this.formGroup.get('nima')?.value &&
        x.suministradorInformacion ===
          this.formGroup.get('suministraInfo')?.value
    );
    if (existe) {
      this.snackBarSrv.showSnackBar(
        'Ya existe una previsión de residuos generados en el SDDR Cerrado introducida',
        'error'
      );
      return;
    }
    this.savingData = true;
    const obj: PrevisionResiduosAdheridoPayloadDTO = {
      anioDatos: this.formGroup.get('anio')?.value,
      codigoLer: { id: this.formGroup.get('codigoLer')?.value?.id },
      nimaGestor: this.formGroup.get('nima')?.value,
      suministradorInformacion: this.formGroup.get('suministraInfo')?.value,
      adherido: { id: this.adheridoInfo.id! },
    };
    this.guardarPrevision(obj);
  }

  guardarPrevision(residuo: PrevisionResiduosAdheridoPayloadDTO): void {
    this.spinnerSrv.loadingShow();
    this.adheridosPrevisionResiduosControllerService.create3(residuo).subscribe({
      next: () => {
        this.gestoresResiduosControllerService
          .findAll8({ nima: [residuo.nimaGestor] }, { page: 0, size: 10 })
          .subscribe({
            next: (data: PageDTOGestoresResiduosDTO) => {
              this.spinnerSrv.loadingHide();
              this.savingData = false;
              if ((data?.datos?.length ?? 0) === 0) {
                this.snackBarSrv.showSnackBar(
                  'Este gestor no está registrado en ENVANET. Le recomendamos que le informe de que debe registrarse, en caso de delegarle el suministro de información por la correcta gestión de sus envases.',
                  'error'
                );
              }
              this.dialogRef.close(true);
            },
            error: () => {
              this.spinnerSrv.loadingHide();
              this.savingData = false;
              this.dialogRef.close(true);
            },
          });
      },
      error: (err) => {
        this.savingData = false;
        this.spinnerSrv.loadingHide();
        const msg =
          err?.status === 409
            ? 'Ya existe una previsión de residuos generados en el SDDR Cerrado introducida'
            : 'Ha ocurrido un error al guardar la previsión de residuos';
        this.snackBarSrv.showSnackBar(msg, 'error');
      },
    });
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
